import { defineMessages } from 'react-intl';

type MessageKeys =
	| 'iconAltText'
	| 'liveRegionDescription'
	| 'loadingAriaTitle'
	| 'loadingAriaNewTitle'
	| 'loadingAnalyzing'
	| 'inlineCommentLoadingAnalyzing'
	| 'loadingEditingTitle'
	| 'inlineCommentLoadingEditingTitle'
	| 'loadingShortening'
	| 'loadingLengthening'
	| 'loadingChangingTone'
	| 'loadingFixingSpellingAndGrammar'
	| 'loadingTranslating'
	| 'loadingPolishing'
	| 'loadingSummarizing';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		iconAltText: {
			id: 'fabric.editor.ai.screens.loading.iconAltText',
			defaultMessage: 'Generating icon',
			description:
				'Alt text for the animated icon displayed on the loading screen of the generative AI modal while content is being generated.',
		},
		liveRegionDescription: {
			id: 'fabric.editor.ai.screens.loading.adfContentAriaLiveRegionDescription',
			defaultMessage: 'Live updating content:',
			description:
				'Description for content that may update frequently and asynchronously. It is hidden and exists for accessibility',
		},
		loadingAriaTitle: {
			id: 'fabric.editor.ai.experience.loadingAriaTitle',
			defaultMessage: 'Generating',
			description:
				'The title string that appears on the "Loading" screen when the user is waiting for Atlassian Intelligence to generate content',
		},
		loadingAriaNewTitle: {
			id: 'fabric.editor.ai.experience.loadingAriaNewTitle',
			defaultMessage: 'Rovo is working',
			description:
				'The title string that appears on the "Loading" screen when the user is waiting for Atlassian Intelligence to generate content',
		},
		loadingAnalyzing: {
			id: 'fabric.editor.ai.experience.loadingAnalyzing',
			defaultMessage: 'Rovo is analyzing',
			description:
				'The title string that appears on the "Loading" screen when the user is waiting for Atlassian Intelligence to generate content',
		},
		inlineCommentLoadingAnalyzing: {
			id: 'fabric.editor.ai.experience.inlineCommentLoadingAnalyzing',
			defaultMessage: 'Analyzing',
			description:
				'The title string that appears on the "Loading" screen when the user is waiting for Atlassian Intelligence to generate content for an inline comment',
		},
		loadingEditingTitle: {
			id: 'fabric.editor.ai.experience.loadingEditingTitle',
			defaultMessage: 'Rovo is editing',
			description:
				'The title string that appears on the "Loading" screen when Atlassian Intelligence is generating content',
		},
		inlineCommentLoadingEditingTitle: {
			id: 'fabric.editor.ai.experience.inlineCommentLoadingEditingTitle',
			defaultMessage: 'Editing',
			description:
				'The title string that appears on the "Loading" screen when Atlassian Intelligence is generating content for an inline comment',
		},
		loadingShortening: {
			id: 'fabric.editor.ai.experience.loadingShortening',
			defaultMessage: 'Rovo is shortening',
			description:
				'The title string that appears on the "Loading" screen when the user is waiting for Atlassian Intelligence to shorten content',
		},
		loadingLengthening: {
			id: 'fabric.editor.ai.experience.loadingLengthening',
			defaultMessage: 'Rovo is lengthening',
			description:
				'The title string that appears on the "Loading" screen when the user is waiting for Atlassian Intelligence to lengthen content',
		},
		loadingChangingTone: {
			id: 'fabric.editor.ai.experience.loadingChangingTone',
			defaultMessage: 'Rovo is changing the tone',
			description:
				'The title string that appears on the "Loading" screen when the user is waiting for Atlassian Intelligence to change the tone of content',
		},
		loadingFixingSpellingAndGrammar: {
			id: 'fabric.editor.ai.experience.loadingFixingSpellingAndGrammar',
			defaultMessage: 'Rovo is fixing spelling and grammar',
			description:
				'The title string that appears on the "Loading" screen when the user is waiting for Atlassian Intelligence to fix the spelling and grammar of content',
		},
		loadingTranslating: {
			id: 'fabric.editor.ai.experience.loadingTranslating',
			defaultMessage: 'Rovo is translating',
			description:
				'The title string that appears on the "Loading" screen when the user is waiting for Atlassian Intelligence to translate content to a different language',
		},
		loadingPolishing: {
			id: 'fabric.editor.ai.experience.loadingPolishing',
			defaultMessage: 'Rovo is polishing',
			description:
				'The title string that appears on the "Loading" screen when the user is waiting for Atlassian Intelligence to polish content',
		},
		loadingSummarizing: {
			id: 'fabric.editor.ai.experience.loadingSummarizing',
			defaultMessage: 'Rovo is summarizing',
			description:
				'The title string that appears on the "Loading" screen when the user is waiting for Atlassian Intelligence to summarize content',
		},
	});

export default message;
